export const MAIN_ACTIONS = {
  REQUESTED: 'main/requested',
  SUCCEEDED: 'main/succeeded',
  FAILED: 'main/failed',
};

export interface MainRequested {
  type: string;
}

export const mainRequested = () => ({
  type: MAIN_ACTIONS.REQUESTED,
});

export interface MainSucceeded {
  type: string;
}

export const mainSucceeded = () => ({
  type: MAIN_ACTIONS.SUCCEEDED,
});

export interface MainFailed {
  type: string;
  error: string;
}

export const mainFailed = (error: string) => ({
  error,
  type: MAIN_ACTIONS.FAILED,
});

export type MainAction = MainRequested | MainSucceeded | MainFailed;



// WEBPACK FOOTER //
// ./src/Main/services/actions.ts